<template>
  <div>
    <h5>Struktur</h5>
    <div class="col-8">
      <div
        v-if="!isLoading"
        class="mb-2"
      >
        <button
          v-if="canUserEdit"
          v-b-tooltip.hover
          class="btn btn-success"
          placement="bottom"
          title="Strukturelement hinzufügen"
          type="button"
          @click="addChildNode()"
        >
          <i class="fas fa-plus" />
        </button>
      </div>
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
        :property-mapping="errorPropertyMappings"
      />
      <u-loader v-if="isLoading" />
      <DraggableTreeView
        v-else
        ref="draggableTreeView"
        v-model="nodes"
        @select="nodeSelected"
      >
        <template
          slot="toggle"
          slot-scope="{ node }"
        >
          <span v-if="node.children && node.children.length > 0">
            <i
              v-if="node.isExpanded"
              class="fa fa-chevron-down"
            />
            <i
              v-if="!node.isExpanded"
              class="fa fa-chevron-right"
            />
          </span>
          <span v-else />
        </template>
        <template
          slot="title"
          slot-scope="{ node }"
        >
          <template v-if="node.data.isEmpty">
            <span class="item-icon float-right">
              <i
                v-b-tooltip.hover
                class="fa fa-plus p-1 structureActionButton"
                placement="bottom"
                title="Struktur hinzufügen"
                @click="addChildNode()"
              />
            </span>
          </template>
          <template v-else>
            <template v-if="editMode && editId == node.data.id">
              <v-text-field
                v-model="editNodeValues.editNodeTitle"
                label="Titel"
              />
              <u-multiline-multilanguage-text-input
                id="structureTreeViewMultiLingual"
                v-model="editNodeValues.contents"
                :languages="
                  $store.state.mindestLohnKonfiguration.BasicContractInformation
                    .translatedLanguages
                "
                content-property-name="value"
              />
            </template>
            <template v-else>
              {{ node.title }}
            </template>

            <span class="item-icon float-right">
              <template v-if="editMode && editId == node.data.id">
                <i
                  v-b-tooltip.hover
                  class="fa fa-check p-1 structureActionButton"
                  placement="bottom"
                  title="Übernehmen"
                  @click="
                    $refs['draggableTreeView'].updateNode(node.path, {
                      title: editNodeValues.editNodeTitle,
                      data: {
                        contents: editNodeValues.contents,
                        id: node.data.id,
                        originalId: node.data.originalId,
                      },
                    });
                    editMode = false;
                    editId = -1;
                  "
                />
                <i
                  v-b-tooltip.hover
                  class="fa fa-times p-1 structureActionButton"
                  placement="bottom"
                  title="Abbrechen"
                  @click="
                    editMode = false;
                    editId = -1;
                  "
                />
              </template>
              <template v-else>
                <i
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="fa fa-pen p-1 structureActionButton"
                  placement="bottom"
                  title="Struktur bearbeiten"
                  @click="
                    editMode = true;
                    editId = node.data.id;
                    editNodeValues.editNodeTitle = node.title;
                    editNodeValues.contents = node.data.contents;
                  "
                />
                <i
                  v-if="canUserEdit"
                  v-b-modal.deleteStructureNode
                  v-b-tooltip.hover
                  class="fa fa-trash-alt p-1 structureActionButton"
                  placement="bottom"
                  title="Struktur löschen"
                  @click="pathToDelete = node.path"
                />
                <i
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="fa fa-plus p-1 structureActionButton"
                  placement="bottom"
                  title="Struktur hinzufügen"
                  @click="addChildNode(node)"
                />
              </template>
            </span>
          </template>
        </template>

        <template slot="draginfo">
          {{ selectedNodesTitle }}
        </template>
      </DraggableTreeView>
      <b-button
        v-if="canUserEdit"
        v-show="!isLoading"
        :disabled="editMode"
        class="mt-2"
        name="saveStrucuture"
        variant="success"
        @click="saveStructure()"
      >
        Speichern
      </b-button>
      <b-button
        v-if="canUserEdit"
        v-show="!isLoading"
        class="mt-2 ml-2"
        name="loadStructure"
        variant="danger"
        @click="
          editMode = false;
          getStructure();
        "
      >
        Abbrechen
      </b-button>
    </div>
    <b-modal
      id="deleteStructureNode"
      ref="deleteStructureNode"
      hide-footer
      no-fade
      title="Struktur löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher das Sie diese Struktur löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteNode()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import DraggableTreeView from "sl-vue-tree";
import { SaveStructure } from "@/services/minimum.wage.services/structure.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

const VUEX_IDENTIFIER = "Structure";

export default {
  components: {
    DraggableTreeView,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      nodes: [],
      nextLeafId: 0,
      structure: null,
      originalStructure: null,
      selectedNodesTitle: null,
      editMode: false,
      editId: -1,
      editNodeValues: {
        editNodeTitle: "",
        contents: [],
      },
      pathToDelete: null,
      allLanguages: [
        { name: "Deutsch", value: "de-CH" },
        { name: "Französisch", value: "fr-CH" },
        { name: "Italienisch", value: "it-CH" },
      ],
    };
  },
  computed: {
    isLoading() {
      return (
        this.$store.getters.isStructureLoading ||
        this.$store.getters.isVersionInformationLoading
      );
    },
    errorObject() {
      return this.$store.state.errorObjects.Structure;
    },
  },
  created() {
    this.$store.dispatch("getVersionInformation", {
      contractId: this.contractId,
      versionId: this.versionId,
    });

    let that = this;

    this.$store.watch(
      (state, getters) => getters.structure,
      (newValue) => {
        that.nextLeafId = 0;
        that.originalStructure = JSON.parse(JSON.stringify(newValue));

        that.nodes = [];

        newValue.map((leaf) => {
          that.nodes.push(that.createTreeViewLeaf(leaf));
        });
      },
    );

    this.getStructure();
  },
  methods: {
    getCurrentLanguagesContents() {
      let counter = 0;
      const contents = [];

      this.$store.state.mindestLohnKonfiguration.BasicContractInformation.translatedLanguages.forEach(
        (translatedLanguage) => {
          contents.push({
            id: 0,
            criteriaStructureId: 0,
            value: "",
            language: translatedLanguage.language,
          });
          counter++;
        },
      );

      if (
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages.length == counter
      ) {
        return contents;
      }
    },
    hideModal() {
      this.$refs["deleteStructureNode"].hide();
    },
    createErrorPropertyMappings(structureToSave) {
      var structureIndex = 0;

      var mapping = {};

      structureToSave.map((strucutureItem) => {
        for (let index = 0; index < 3; index++) {
          mapping[`[${structureIndex}].Contents[${index}].Value`] = `${
            strucutureItem.name
          } ${this.allLanguages[index].name}`;
        }

        this.addChildToMapping(strucutureItem, mapping, `[${structureIndex}]`);

        structureIndex++;
      });

      return mapping;
    },
    addChildToMapping(strucutureItem, mapping, previousString) {
      var childIndex = 0;

      if (strucutureItem.children.length > 0) {
        strucutureItem.children.map((childItem) => {
          for (let index = 0; index < 3; index++) {
            mapping[
              `${previousString}.Children[${childIndex}].Contents[${index}].Value`
            ] = `${childItem.name} ${this.allLanguages[index].name}`;
          }

          this.addChildToMapping(
            childItem,
            mapping,
            `${previousString}.Children[${childIndex}]`,
          );

          childIndex++;
        });
      }
    },
    getStructure() {
      this.$store.dispatch("getStructure", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.editionId,
      });
    },
    saveStructure() {
      this.startLoading(VUEX_IDENTIFIER);

      var structureToSave = [];
      this.nodes.map((node) => {
        structureToSave.push(this.createStructureNode(node));
      });

      this.errorPropertyMappings =
        this.createErrorPropertyMappings(structureToSave);

      SaveStructure(
        this.contractId,
        this.versionId,
        this.editionId,
        structureToSave,
        () => {
          this.getStructure();
        },
        (error) => {
          this.stopLoading(VUEX_IDENTIFIER, error);
        },
      );
    },
    createStructureNode(node) {
      var newNode = {
        name: node.title,
        id: node.data.originalId,
        contents: node.data.contents,
        children: [],
      };

      if (node.children && node.children.length > 0) {
        node.children.map((child) => {
          newNode.children.push(this.createStructureNode(child));
        });
      }

      return newNode;
    },
    createTreeViewLeaf(structureNode) {
      this.nextLeafId = this.nextLeafId + 1;
      var newLeaf = {
        title: structureNode.name,
        children: [],
        data: {
          id: this.nextLeafId,
          originalId: structureNode.id,
          contents:
            structureNode.contents.length > 0
              ? structureNode.contents
              : this.getCurrentLanguagesContents(),
        },
      };

      if (structureNode.children && structureNode.children.length > 0) {
        structureNode.children.map((child) => {
          newLeaf.children.push(this.createTreeViewLeaf(child));
        });
      }

      return newLeaf;
    },
    nodeSelected(nodes) {
      this.selectedNodesTitle = nodes.map((node) => node.title).join(", ");
    },
    deleteNode() {
      var draggableTreeView = this.$refs["draggableTreeView"];
      draggableTreeView.remove([this.pathToDelete]);
      this.pathToDelete = null;
      this.hideModal();
    },

    addChildNode(node) {
      this.nextLeafId = this.nextLeafId + 1;

      if (node) {
        this.addNodeToLeaf(node.data.id);
      } else {
        this.nodes.push({
          title: "Neu" + this.nextLeafId,
          data: {
            id: this.nextLeafId,
            contents: this.getCurrentLanguagesContents(),
          },
        });
      }
    },
    getNodeFromChildrenCollection(collection, id) {
      var returnItem = null;

      collection.map((item) => {
        if (item.data.id == id) {
          returnItem = item;
        } else if (item.children && item.children.length > 0) {
          var test = this.getNodeFromChildrenCollection(item.children, id);
          if (test) {
            returnItem = test;
          }
        }
      });

      return returnItem;
    },
    addNodeToLeaf(leafId) {
      this.nextLeafId = this.nextLeafId + 1;

      var nodeToAddChildTo = this.getNodeFromChildrenCollection(
        this.nodes,
        leafId,
      );

      if (!nodeToAddChildTo.children) {
        nodeToAddChildTo.children = [];
      }

      nodeToAddChildTo.children.push({
        title: "Neu" + this.nextLeafId,
        data: {
          id: this.nextLeafId,
          contents: this.getCurrentLanguagesContents(),
        },
      });
    },
  },
};
</script>

// Styling the Treeview
<style>
.structureActionButton {
  color: #ccc;
  cursor: pointer;
}

.structureActionButton:hover {
  color: #222;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item .structureActionButton {
  color: #999;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item .structureActionButton:hover {
  color: #222;
}

.sl-vue-tree-title {
  width: 100%;
}

/* 
.sl-vue-tree-node-item:hover{
    background-color: #eee;
} */

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  border: 1px solid rgb(9, 22, 29);
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: rgb(204, 204, 204);
  color: black;
}

.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  color: black;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 28px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid black;
}

.sl-vue-tree-gap {
  width: 25px;
  min-height: 1px;
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid black;
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.5;
  margin-left: 20px;
  padding: 5px 10px;
}
</style>
